export default {
    minutesToMs(minutes) {
        return minutes * 60000;
    }
};